<template>
  <div>
    <i-navbar id="navbar" size="md">
      <i-navbar-brand href="#" v-scroll-to="{el: '#header'}"><img alt="TILA navigation logo" id="navbar-logo" class="logo fade-out" height="45" src="./../assets/logo.svg"/></i-navbar-brand>
      <i-navbar-items class="_justify-content-end">
        <i-nav class="nav">
          <i-nav-item class="text-colour" href="#" v-scroll-to="{el: '#about-scroll-to', offset: 0}">{{ $t("nav.about") }}</i-nav-item>
          <i-nav-item class="text-colour" href="#" v-scroll-to="{el: '#cards-scroll-to', offset: 0}">{{ $t("nav.projects") }}</i-nav-item>
          <i-nav-item class="text-colour" href="#" v-scroll-to="{el: '#contact-scroll-to', offset: 0}">{{ $t("nav.contact") }}</i-nav-item>
          <i-nav-item @click.native="changeLanguage">
            <flag v-if="$i18n.locale === 'en'" class="" iso="sk" :squared="false" />
            <flag v-else class="" iso="gb" :squared="false"/>
          </i-nav-item>
        </i-nav>
      </i-navbar-items>
    </i-navbar>

    <i-layout>
      <i-header id="header" :cover="true" fluid fullscreen class="_text-center">
        <div class="container -fluid">
          <div class="container">
            <h1>
              <img id="tila-logo" alt="TILA header logo" class="logo" src="./../assets/header-logo.svg"/>
            </h1>
          </div>
        </div>
      </i-header>

      <i-layout-content>
        <div id="about-scroll-to" class="container -fluid bg-colour text-colour">
          <div class="container">
            <i-row id="#about-header" class="_text-center">
              <i-column xs="12">
                <h2>{{ $t("nav.about") }}</h2>
              </i-column>
            </i-row>
            <i-row class="_text-center">
              <i-column xs="12">
                <p class="lead _margin-bottom-3 _margin-top-1">{{ $t("p.leadAboutA") }}<img alt="Tila" class="in-text-logo" src="./../assets/logo.svg"/>
                  {{ $t("p.leadAboutB") }}</p>
              </i-column>
            </i-row>
            <i-row middle-md id="about" class="_text-center _justify-content-center">
              <i-column xs="12" md="6" center-md lg="2" class="_margin-bottom-2">
                <i-card id="stcard" size="sm">
                  <img slot="image" src="./../assets/skrajcovic_photo.png" alt="Stanislav Krajčovič photo" />
                </i-card>
              </i-column>
              <i-column xs="12" lg="10" class="_margin-bottom-xs-2 _margin-bottom-sm-3 _margin-bottom-md-3">
                <blockquote class="blockquote -right">
                  <p>{{ $t("p.cards.stano") }}</p>
                  <footer><cite title="Stanislav Krajčovič">Stanislav Krajčovič</cite></footer>
                </blockquote>
              </i-column>

              <i-column xs="12" lg="10" last-xs>
                <blockquote class="blockquote -right">
                  <p>{{ $t("p.cards.maco") }}</p>
                  <footer><cite title="Martin Maco">Martin Maco</cite></footer>
                </blockquote>
              </i-column>
              <i-column xs="12" md="6" lg="2">
                <i-card id="mmcard" size="sm">
                  <img slot="image" src="./../assets/mmaco_photo.png" alt="Martin Maco photo" />
                </i-card>
              </i-column>
            </i-row>
          </div>
        </div>

        <div id="cards-scroll-to" class="container -fluid bg-colour text-colour">
          <div class="container">
            <i-row class="_text-center _align-middle">
              <i-column>
                <h2>{{ $t("nav.projects") }}</h2>
              </i-column>
            </i-row>
            <i-row class="_text-center">
              <i-column xs="12">
                <p class="lead _margin-bottom-3 _margin-top-1">{{ $t("p.leadProjects") }}</p>
              </i-column>
            </i-row>
            <i-row id="cards" class="tila-row _text-center">
              <i-column xs="12" md="6" lg="3">
                <i-card class="bg-colour text-colour _margin-bottom-xs-1 _margin-bottom-sm-1 _margin-bottom-md-1">
                  <div class="card-header-img" slot="image">{{ $t("p.cards.kalendariumTitle") }}</div>
                  <p>
                    {{ $t("p.cards.kalendarium") }}
                  </p>
                  <template slot="footer">
                    <i-button v-on:click="visible=true">{{ $t("buttons.view") }} <font-awesome-icon :icon="['fas', 'arrow-right']" /></i-button>
                  </template>
                </i-card>
              </i-column>

              <i-column xs="12" md="6" lg="3">
                <i-card class="bg-colour text-colour _margin-bottom-xs-1 _margin-bottom-sm-1 _margin-bottom-md-1">
                  <div class="card-header-img" slot="image">{{ $t("p.cards.laroksTitle") }}</div>
                  <p>
                    {{ $t("p.cards.laroks") }}
                  </p>
                  <template slot="footer"><i-button href="http://laroks.sk/">{{ $t("buttons.visit") }} <font-awesome-icon :icon="['fas', 'arrow-right']" /></i-button></template>
                </i-card>
              </i-column>

              <i-column xs="12" md="6" lg="3">
                <i-card class="bg-colour text-colour _margin-bottom-xs-1 _margin-bottom-sm-1 _margin-bottom-md-1">
                  <div class="card-header-img" slot="image">{{ $t("p.cards.sdlcdTitle") }}</div>
                  <p>
                    {{ $t("p.cards.sdlcd") }}
                  </p>
                  <template slot="footer"><i-button disabled href="http://ago.fmph.uniba.sk/~krajcovic/">{{ $t("buttons.visit") }} <font-awesome-icon :icon="['fas', 'arrow-right']" /></i-button></template>
                </i-card>
              </i-column>

              <i-column xs="12" md="6" lg="3">
                <i-card id="your-project" class="bg-colour text-colour _margin-bottom-xs-1 _margin-bottom-sm-1 _margin-bottom-md-1">
                  <img slot="image" src="./../assets/logo.svg" alt="Card Image" />
                  <p>
                    {{$t("p.cards.yourProject")}}
                  </p>
                  <template slot="footer"><i-button href="mailto:kontakt@tila.sk">{{ $t("buttons.contact") }} <font-awesome-icon :icon="['fas', 'arrow-right']" /></i-button></template>
                </i-card>
              </i-column>
            </i-row>
          </div>
        </div>

        <div class="container -fluid bg-colour text-colour">
          <div class="container">
            <i-row class="_text-center">
              <i-column xs="12" class="_margin-bottom-1">
                <h2>{{ $t("nav.contact") }}</h2>
              </i-column>
            </i-row>
            <i-row>
              <i-column xs="12" md="4" offset-md="3" class="_text-center-xs _text-center-sm">
                <ul class="list -unstyled">
                  <li><font-awesome-icon :icon="['fas', 'user-tie']" />&nbsp;Tila s.r.o.</li>
                  <li><font-awesome-icon :icon="['fas', 'map-marked-alt']" />&nbsp;Kulíškova 17</li>
                  <li><font-awesome-icon :icon="['fas', 'envelope']" />&nbsp;821 08 Bratislava 2</li>
                  <li></li>
                  <li>
                    <i-tooltip trigger="hover" variant="dark" placement="bottom">
                      <span><font-awesome-icon :icon="['fas', 'briefcase']" />&nbsp;<u>51 989 409</u></span>
                      <template slot="body">{{ $t("ico") }}</template>
                    </i-tooltip>
                  </li>
                </ul>
              </i-column>

              <i-column xs="12" md="4" class="_text-center-xs _text-center-sm">
                <ul class="list -unstyled">
                  <li><font-awesome-icon :icon="['fas', 'user-tie']" />&nbsp;<a href="mailto:kontakt@tila.sk">kontakt@tila.sk</a></li>
                  <li><font-awesome-icon :icon="['fab', 'linkedin']" />&nbsp;<a href="https://www.linkedin.com/company/tila-s-r-o/">linkedin.com</a></li>
<!--                  <li><font-awesome-icon :icon="['fas', 'mobile']" />&nbsp;<a href="tel://+421910626161">+421 910 123 456</a></li>-->
                </ul>
              </i-column>
            </i-row>
          </div>
        </div>
      </i-layout-content>

      <i-layout-footer id="tila-footer" class="bg-colour text-colour">
        <div id="contact-scroll-to" class="container -fluid">
          <div class="container">
            <i-row id="contact" class="_text-center">
              <i-column xs="12">
                <p id="footer-copyright">copyright <font-awesome-icon :icon="['far', 'copyright']" /> 2018 - 2019, Tila s.r.o.</p>
              </i-column>
            </i-row>
          </div>
        </div>
      </i-layout-footer>
    </i-layout>

    <i-modal v-model="visible" size="lg">
      <template slot="header"><div id="modal-header-div">Modal Header</div></template>
      <div id="modal-inside-div" class="_padding-top-0 _padding-left-1 _padding-right-1 _margin-bottom-1">
        <swiper :options="swiperOptions">
          <swiper-slide>
            <img src="./../assets/kalendarium1.png" class="image" alt="Fluid image">
          </swiper-slide>
          <swiper-slide>
            <img src="./../assets/kalendarium2.png" class="image" alt="Fluid image">
          </swiper-slide>
          <swiper-slide>
            <img src="./../assets/kalendarium3.png" class="image" alt="Fluid image">
          </swiper-slide>
          <swiper-slide>
            <img src="./../assets/kalendarium4.png" class="image" alt="Fluid image">
          </swiper-slide>
          <swiper-slide>
            <img src="./../assets/kalendarium5.png" class="image" alt="Fluid image">
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <span><strong>{{ $t("p.cards.kalendariumTitle") }}</strong>{{ $t("modalKalendarium") }}</span>
    </i-modal>
  </div>
</template>

<script>
  export default {
    name: 'HomePage',
    data () {
      return {
        swiperOptions: {
          spaceBetween: 30,
          grabCursor: true,
          loop: true,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
          },
          autoHeight: true
        },
        visible: false,
      }
    },
    methods: {
      changeLanguage: function () {
        console.log('test')
        if (this.$i18n.locale === 'en') {
          this.$i18n.locale = 'sk';
        } else this.$i18n.locale = 'en';
      }
    }
  }
</script>

<style scoped>
  .nav >>> .item {
    cursor: pointer;
  }

  .nav >>> .item  {
    -ms-filter: grayscale(30%);
    filter: grayscale(30%);
  }

  .swiper-slide > img {
    max-height: 60vh;
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }

  body {
    height: 100%;
  }

  #tila-logo{
    height: 30vw;
  }
  .text-colour {
    color: #30343F !important;
  }

  .bg-colour {
    background-color: #fff !important;
  }

  .tila-row {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  #footer-copyright {
    font-size: .8rem;
    color: #D7E7ED;
  }

  #navbar {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 2000;

    -webkit-transition: all 0.2s ease-in-out 0s;
    -moz-transition: all 0.2s ease-in-out 0s;
    -ms-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;

    background-color: transparent;
    visibility: hidden;
    opacity: 0;
  }

  #navbar.shown {
    opacity: 1;
    visibility: visible;
    background-color: #fff;
  }

  .-fluid {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  img {
    vertical-align: middle;
  }

  #navbar-logo {
    -webkit-transition: all 0.2s ease-in-out 0s;
    -moz-transition: all 0.2s ease-in-out 0s;
    -ms-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;

    visibility: hidden;
    opacity: 0;
  }

  #navbar-logo.fade {
    visibility: visible;
    opacity: 1;
  }

  .fade-out {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }

  u:hover {
    cursor: help;
    text-decoration: none;
  }

  #your-project {
    border: 5px solid #247BA0;
  }

  #your-project >>> .footer {
    border-bottom: none;
    padding-bottom: .9rem;
  }

  #tila-footer div {
    padding-bottom: 0;
  }

  .card-header-img {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    color: white;
    font-size: 1.5rem;
    font-weight: 300;
    background: url("./../assets/bgg.jpg") no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  #header {
    background: url("./../assets/bgg.jpg") no-repeat fixed center;
    background-size: cover;
  }

  @media only screen and (max-width:749px) {
    #header {
      background-attachment: inherit;
    }
  }

  #about p {
    text-align: justify;
  }

  #cards .button {
    color: white;
    background-color: #247BA0;

    transition: background-color .21s ease, border-color .21s ease,color .21s ease;
  }

  #cards .button:hover {
    color: #30343F;
    background-color: #D7E7ED !important;
  }

  .nav > .item:hover {
    background-color: #D7E7ED;
    -webkit-border-radius: .25rem;
    -moz-border-radius: .25rem;
    border-radius: .25rem;
  }

  a {
    color: #247BA0;
  }

  .card >>> .footer {
    background-color: white!important;
    border-color: #D7E7ED;
  }

  .card >>> .body {
    border-color: #D7E7ED;
  }

  #mmcard >>> img, #stcard >>> img {
    -webkit-border-radius: .25rem;
    -moz-border-radius: .25rem;
    border-radius: .25rem;
  }

  .in-text-logo {
    max-height: 1.75rem;
  }

  #stcard >>> .body {
    padding: 0 0 10px;
    margin: 0;
    border: none;
  }

  #mmcard >>> .body {
    padding: 0;
    margin: 0;
    border: none;
  }

  #mmcard >>> img {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }

  .blockquote {
    font-size: 1rem;
  }

  blockquote > footer {
    color: #247BA0;
  }

  ::selection {
    background: #D7E7ED;
  }
  ::-moz-selection {
    background: #D7E7ED;
  }
</style>
